import { render, staticRenderFns } from "./ruler.vue?vue&type=template&id=33156f96&"
import script from "./ruler.vue?vue&type=script&lang=js&"
export * from "./ruler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports